import React, { Component } from "react";

class ContentPartners extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className="detail-gallery">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={21}
          data-mobile={21}
          data-smobile={21}
        />
        <div
          className="themesflat-gallery style-2 has-arrows arrow-center arrow-circle offset-v-82 has-thumb w185 clearfix"
          data-gap={0}
          data-column={1}
          data-column2={1}
          data-column3={1}
          data-auto="false"
        >
          <div className="owl-carousel owl-theme">
            {data.images.map((image) => (
              <div className="gallery-item" key={image}>
                <div className="inner">
                  <div className="thumb">
                    <img src={image} alt={`${data.partnerName} - CityX`} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* /.themesflat-cousel-box */}
        <div
          className="themesflat-spacer clearfix"
          data-desktop={40}
          data-mobile={40}
          data-smobile={40}
        />
        <div className="flat-content-wrap style-3 clearfix">
          <h5 className="title">{data.partnerName}</h5>
          <div className="sep has-width w60 accent-bg margin-top-18 clearfix" />
          <div
            className="margin-top-28"
            dangerouslySetInnerHTML={{ __html: data.description }}
          />
        </div>
      </div>
    );
  }
}

export default ContentPartners;
